"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePurchasedGoodsKeyForChildGood = generatePurchasedGoodsKeyForChildGood;
exports.getCreateButtonText = getCreateButtonText;
exports.sortAndFilterGoods = sortAndFilterGoods;
exports.isValidPaymentType = isValidPaymentType;
exports.getGoodFromId = getGoodFromId;
exports.getFirstPendingGood = getFirstPendingGood;
exports.getRowClassName = getRowClassName;
exports.getGoodDeliveryState = getGoodDeliveryState;
exports.hasDeliverySucceeded = hasDeliverySucceeded;
exports.hasCustomerReviewedGood = hasCustomerReviewedGood;
exports.hasRequestedRefund = hasRequestedRefund;
exports.isGoodRefundable = isGoodRefundable;
exports.canCreateAsset = canCreateAsset;
exports.getUserGuideLinkInfoForSubType = getUserGuideLinkInfoForSubType;
exports.isPollingGood = isPollingGood;
exports.getChildTemplatePath = getChildTemplatePath;
exports.getChildDestinationId = getChildDestinationId;
exports.getMostRecentGoodDeliverInfo = getMostRecentGoodDeliverInfo;
exports.getTemplatePathForGoodNotInPack = getTemplatePathForGoodNotInPack;
exports.getPackChildrenInUseDestinationIds = getPackChildrenInUseDestinationIds;
exports.getDestinationIdForGoodNotInPack = getDestinationIdForGoodNotInPack;
exports.getPackChildrenDestinationIds = getPackChildrenDestinationIds;
exports.getPackChildrenInUse = getPackChildrenInUse;
exports.getIsSiteOrLandingPage = getIsSiteOrLandingPage;
exports.getHasChildSiteOrLandingPage = getHasChildSiteOrLandingPage;

var _underscore = _interopRequireDefault(require("underscore"));

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _immutable = require("immutable");

var _GoodSubTypes = _interopRequireDefault(require("../../constants/GoodSubTypes"));

var _ManagePurchasesColumns = _interopRequireDefault(require("../../constants/ManagePurchasesColumns"));

var _PaymentMethods = _interopRequireDefault(require("../../constants/PaymentMethods"));

var _RowDeliveryState = _interopRequireDefault(require("../../constants/RowDeliveryState"));

var _SortOrderOptions = _interopRequireDefault(require("../../constants/SortOrderOptions"));

var _HubspotUrls = require("../../constants/HubspotUrls");

var _utils = require("../utils");

var _langUtils = require("../langUtils");

var _RequestStatusTypes = _interopRequireDefault(require("../../constants/RequestStatusTypes"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../../constants/GoodSubTypeGroups"));

var _sidebarUtils = require("../sidebarUtils");

var _refunds = require("marketplace-lib/utils/refunds");

function generatePurchasedGoodsKeyForChildGood(_ref) {
  var childId = _ref.childId,
      parentId = _ref.parentId;
  return "" + childId + parentId;
}

function getCreateButtonText(subType) {
  return _I18n.default.text("managePurchases.dropdown.createOption." + subType);
}

function filterByProductType(productTypeFilter, purchasedGoods, goodId) {
  if (productTypeFilter === _GoodSubTypes.default.ALL) {
    return true;
  } else if (productTypeFilter === _GoodSubTypeGroups.default.TEMPLATES) {
    return _sidebarUtils.templateOptions.has(purchasedGoods.getIn([goodId, 'subType']));
  } else {
    return purchasedGoods.getIn([goodId, 'subType']) === productTypeFilter;
  }
}

function filterBySearch(currentSearchFilter, purchasedGoods, goodId) {
  var filter = currentSearchFilter.toLowerCase();

  if (filter === '') {
    return true;
  }

  return purchasedGoods.getIn([goodId, _ManagePurchasesColumns.default.PRODUCT_NAME]).toLowerCase().indexOf(filter) !== -1;
}

function filterByDeliveryStatus(deliveryStatusFilter, purchasedGoods, goodId) {
  var deliveryStatus = purchasedGoods.getIn([goodId, 'deliveryStatus']);

  switch (deliveryStatusFilter) {
    case 'uninstalled':
      return deliveryStatus === _RowDeliveryState.default.UNINSTALLED;

    case 'failed':
      return deliveryStatus === _RequestStatusTypes.default.FAILED;

    case 'installed':
      return deliveryStatus !== _RowDeliveryState.default.UNINSTALLED && deliveryStatus !== _RequestStatusTypes.default.FAILED;

    default:
      return true;
  }
}

function getTranslatedTextIfSortingByType(sortByField, val) {
  if (sortByField === _ManagePurchasesColumns.default.PRODUCT_TYPE) {
    return (0, _langUtils.getFriendlyCategoryFilterName)(val);
  }

  return val;
}

function sortAndFilterGoods(purchasedGoodsDisplayOrder, purchasedGoods, currentSearchFilter, sortBy, sortOrder, productTypeFilter, deliveryStatusFilter) {
  return purchasedGoodsDisplayOrder.filter(filterBySearch.bind(null, currentSearchFilter, purchasedGoods)).filter(filterByProductType.bind(null, productTypeFilter, purchasedGoods)).filter(filterByDeliveryStatus.bind(null, deliveryStatusFilter, purchasedGoods)).sort(function (goodId1, goodId2) {
    var val1 = purchasedGoods.getIn([goodId1, sortBy]);
    var val2 = purchasedGoods.getIn([goodId2, sortBy]);
    val1 = getTranslatedTextIfSortingByType(sortBy, val1);
    val2 = getTranslatedTextIfSortingByType(sortBy, val2);
    var comparisonResult = 0;

    if (_underscore.default.isString(val1)) {
      comparisonResult = val1.localeCompare(val2);
    } else {
      if (val1 > val2) {
        comparisonResult = 1;
      } else if (val2 > val1) {
        comparisonResult = -1;
      }
    }

    if (sortOrder === _SortOrderOptions.default.DESC) {
      comparisonResult *= -1;
    }

    return comparisonResult;
  });
}

function isValidPaymentType(paymentType) {
  return _underscore.default.contains(_PaymentMethods.default, paymentType);
}

function getGoodFromId(goods, goodId) {
  return goods.find(function (good) {
    return good.get('goodId') === goodId;
  });
}

function getFirstPendingGood(purchasedGoodsDisplayOrder, purchasedGoods) {
  return purchasedGoodsDisplayOrder.find(function (goodId) {
    return purchasedGoods.getIn([goodId, 'deliveryStatus']) === _RequestStatusTypes.default.PENDING;
  });
}

function getDeliveryStateClass(rowDeliveryState) {
  switch (rowDeliveryState) {
    case _RowDeliveryState.default.DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING:
      return 'delivery-succeeded';

    case _RowDeliveryState.default.DELIVERY_PENDING_AND_POLLING_STATUS:
    case _RowDeliveryState.default.DELIVERY_PENDING_AND_NOT_POLLING_STATUS:
      return 'delivery-pending';

    case _RowDeliveryState.default.DELIVERY_FAILED:
      return 'delivery-failed';

    default:
      return '';
  }
}

function getRowClassName(rowDeliveryState, isActiveGood, isDropdownOpen) {
  return (0, _classnames.default)({
    active: isActiveGood
  }, 'pointer', 'integrate-purchased-good-row', 'purchased-good-row', {
    'dropdown-open': isDropdownOpen
  }, getDeliveryStateClass(rowDeliveryState));
}

function getGoodDeliveryState(goodDeliveryStatus, isPollingGoodBool, pollingGoodStatus) {
  if (isPollingGoodBool) {
    switch (pollingGoodStatus) {
      case _RequestStatusTypes.default.SUCCEEDED:
        return _RowDeliveryState.default.DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING;

      case _RequestStatusTypes.default.PENDING:
        return _RowDeliveryState.default.DELIVERY_PENDING_AND_POLLING_STATUS;

      case _RequestStatusTypes.default.FAILED:
        return _RowDeliveryState.default.DELIVERY_FAILED;

      default:
        return '';
    }
  }

  switch (goodDeliveryStatus) {
    case _RequestStatusTypes.default.SUCCEEDED:
      return _RowDeliveryState.default.DELIVERY_SUCCEEDED_BEFORE_LAST_PAGE_LOAD;

    case _RequestStatusTypes.default.PENDING:
      return _RowDeliveryState.default.DELIVERY_PENDING_AND_NOT_POLLING_STATUS;

    case _RequestStatusTypes.default.FAILED:
      return _RowDeliveryState.default.DELIVERY_FAILED;

    case _RowDeliveryState.default.UNINSTALLED:
      return _RowDeliveryState.default.UNINSTALLED;

    case _RowDeliveryState.default.REFUNDED:
      return _RowDeliveryState.default.REFUNDED;

    default:
      return '';
  }
}

function hasDeliverySucceeded(goodDeliveryState) {
  return goodDeliveryState === _RowDeliveryState.default.DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING || goodDeliveryState === _RowDeliveryState.default.DELIVERY_SUCCEEDED_BEFORE_LAST_PAGE_LOAD || goodDeliveryState === _RowDeliveryState.default.UNINSTALLED || goodDeliveryState === _RowDeliveryState.default.REFUNDED;
}

function hasCustomerReviewedGood(good) {
  return !!good.get('review');
}

function hasRequestedRefund(refund) {
  return !!refund && !(0, _refunds.isCanceled)(refund);
}

function isGoodRefundable(good) {
  return !good.get('parentId') && !good.get('isFree') && !hasRequestedRefund(good.get('refund'));
}

function canCreateAsset(good) {
  return (good.get('subType') === _GoodSubTypes.default.LANDING_PAGES || good.get('subType') === _GoodSubTypes.default.SITE_PAGES || good.get('subType') === _GoodSubTypes.default.EMAIL_TEMPLATES) && !!good.get('templatePath') && good.get('deliveryStatus') !== _RowDeliveryState.default.UNINSTALLED;
}

function getUserGuideLinkInfoForSubType(subType) {
  if (subType === _GoodSubTypes.default.LANDING_PAGES) {
    return {
      text: _I18n.default.text('managePurchases.detailsRow.userGuideLink.landingPage'),
      url: _HubspotUrls.USER_GUIDES.LANDING_PAGE
    };
  } else if (subType === _GoodSubTypes.default.BLOG_TEMPLATES) {
    return {
      text: _I18n.default.text('managePurchases.detailsRow.userGuideLink.blog'),
      url: _HubspotUrls.USER_GUIDES.BLOG
    };
  } else if (subType === _GoodSubTypes.default.EMAIL_TEMPLATES) {
    return {
      text: _I18n.default.text('managePurchases.detailsRow.userGuideLink.email'),
      url: _HubspotUrls.USER_GUIDES.EMAIL
    };
  } else if (subType === _GoodSubTypes.default.SITE_PAGES || (0, _utils.isSystemPage)(subType)) {
    return {
      text: _I18n.default.text('managePurchases.detailsRow.userGuideLink.website'),
      url: _HubspotUrls.USER_GUIDES.WEBSITE
    };
  }

  return {
    text: _I18n.default.text('managePurchases.detailsRow.userGuideLink.general'),
    url: _HubspotUrls.USER_GUIDES.GENERAL
  };
}

function isPollingGood(pollingGoodId, goodId) {
  return pollingGoodId === goodId || pollingGoodId === Number(goodId);
}

function getChildTemplatePath(goodDeliverInfo, child) {
  if (!_underscore.default.isArray(goodDeliverInfo)) {
    return '';
  }

  var childTemplateIdAndPath = _underscore.default.find(goodDeliverInfo, function (idAndPath) {
    return idAndPath.goodVersionId === Number(child.goodVersionId);
  });

  return childTemplateIdAndPath ? childTemplateIdAndPath.destinationLocator : '';
}

function getChildDestinationId(goodDeliverInfo, child) {
  if (!_underscore.default.isArray(goodDeliverInfo)) {
    return '';
  }

  var childTemplateIdAndPath = _underscore.default.find(goodDeliverInfo, function (idAndPath) {
    return idAndPath.goodVersionId === Number(child.goodVersionId);
  });

  return childTemplateIdAndPath ? childTemplateIdAndPath.destinationId : '';
}

function getMostRecentGoodDeliverInfo(goodDeliverInfo, key) {
  return _underscore.default.isArray(goodDeliverInfo) && goodDeliverInfo.length && goodDeliverInfo[0][key] || '';
}

function getTemplatePathForGoodNotInPack(goodDeliverInfo) {
  return getMostRecentGoodDeliverInfo(goodDeliverInfo, 'destinationLocator');
}

function getPackChildrenInUseDestinationIds(response) {
  return (0, _immutable.fromJS)(Object.keys(response)).filter(function (destinationId) {
    return response[destinationId].length;
  });
}

function getDestinationIdForGoodNotInPack(goodDeliverInfo) {
  return getMostRecentGoodDeliverInfo(goodDeliverInfo, 'destinationId');
}

function getPackChildrenDestinationIds(goodToRefund, purchasedGoods) {
  return goodToRefund.get('packChildrenDisplayOrder').map(function (childId) {
    return purchasedGoods.getIn([generatePurchasedGoodsKeyForChildGood({
      childId: childId,
      parentId: goodToRefund.get('goodId')
    }), 'destinationId']);
  });
}

function getPackChildrenInUse(childrenInUseDestinationIds, goodToRefund, purchasedGoods) {
  return goodToRefund.get('packChildrenDisplayOrder').filter(function (childId) {
    return childrenInUseDestinationIds.includes(purchasedGoods.getIn([generatePurchasedGoodsKeyForChildGood({
      childId: childId,
      parentId: goodToRefund.get('goodId')
    }), 'destinationId']));
  }).map(function (childId) {
    return purchasedGoods.get(generatePurchasedGoodsKeyForChildGood({
      childId: childId,
      parentId: goodToRefund.get('goodId')
    }));
  });
}

function getIsSiteOrLandingPage(subType) {
  return subType === _GoodSubTypes.default.LANDING_PAGES || subType === _GoodSubTypes.default.SITE_PAGES;
}

function getHasChildSiteOrLandingPage(parentId, purchasedGoods) {
  return purchasedGoods.filter(function (good) {
    return good.get('parentId') === parentId;
  }).some(function (good) {
    return getIsSiteOrLandingPage(good.get('subType'));
  });
}